import { render } from "./Trunquee.vue?vue&type=template&id=3cb66218&scoped=true"
import script from "./Trunquee.vue?vue&type=script&lang=js"
export * from "./Trunquee.vue?vue&type=script&lang=js"

import "./Trunquee.vue?vue&type=style&index=0&id=3cb66218&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\webtv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb66218"]])

export default __exports__